import React, { memo } from 'react';
import cn from 'classnames';
import { Collapse } from 'reactstrap';

import './ExpandedRadioButton.scss';

type Props = {
  option: string;
  label: string;
  isSelected: boolean;
  onClick: Function;
  children?: React.ReactNode;
};

function ExpandedRadioButton({ option, label, onClick, isSelected, children }: Props) {
  const handleItemClick = () => onClick(option);

  return (
    <div className="ExpandedRadioButton d-flex flex-column cursor-pointer rounded p-2 mb-3" onClick={handleItemClick}>
      <div className="d-flex align-items-center">
        <div className="ExpandedRadioButton__circle d-flex justify-content-center align-items-center mr-2">
          <div className={cn({ 'ExpandedRadioButton__circle--is-selected': isSelected })} />
        </div>
        {label}
      </div>
      <Collapse isOpen={isSelected}>
        <div className={cn({ 'py-2': Boolean(children) })}>{children}</div>
      </Collapse>
    </div>
  );
}

export default memo(ExpandedRadioButton);
